export const formatFixed = (val, dp) => {
    if (val == null) {
        return "-";
    } else {
        return val.toFixed(dp);
    }
}